export const FrameworkPackageName = "gadget-server";
